import React, { useState } from 'react';
import { getApplicationId, getIsSalesForce, ScreenProps } from '@fnol/library/src/lib';
import { Button, DataProcessingContent } from '@fnol/library/src/components';
import { translations, common } from '@fnol/library/src/lib/consts';
import { Box, Checkbox, FormControlLabel, FormHelperText, Typography } from '@mui/material';
import { useFormikContext } from 'formik';

interface FormData {
    introMessagesAgreement: boolean;
}

export const ThirdMessage = ({ navigator }: ScreenProps) => {
    const [currentStep, { goForward, goBack }] = navigator;
    const { setFieldValue, values } = useFormikContext<FormData>();
    const [showAgreementMessage, setShowAgreementMessage] = useState(false);
    const [introMessagesAgreement, setIntroMessagesAgreement] = useState(false);

    const handleNext = () => {
        if (introMessagesAgreement) {
            goForward();
            setShowAgreementMessage(false);
            setFieldValue('introMessagesOpen', false);
        } else {
            setShowAgreementMessage(true);
        }
    };

    const onCheckBoxChange = (e: any) => {
        setIntroMessagesAgreement(e.target.checked);
    };

    return (
        <>
            <DataProcessingContent />
            <Box sx={{ width: '100%', paddingTop: '15px' }}>
                <FormControlLabel
                    name="introMessagesAgreement"
                    id="introMessagesAgreement"
                    control={<Checkbox checked={introMessagesAgreement} />}
                    onChange={onCheckBoxChange}
                    label={
                        <Typography style={{ fontSize: '13px' }}>
                            {translations.intro.ACCEPT_DATA_PROCESSING}
                        </Typography>
                    }
                    componentsProps={{ typography: { fontSize: '13px' } }}
                />
                {!introMessagesAgreement && showAgreementMessage && (
                    <FormHelperText error={true}>
                        <>{translations.intro.ACCEPT_DATA_PROCESSING_NOTIFICATION}</>
                    </FormHelperText>
                )}
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: !getIsSalesForce(getApplicationId()) ? 'space-between' : 'flex-end',
                    width: '100%',
                    paddingTop: '15px',
                }}
            >
                {!getIsSalesForce(getApplicationId()) && <Button onClickHandler={goBack} label={common.PREVIOUS} />}
                <Button onClickHandler={handleNext} label={common.CLOSE} />
            </Box>
        </>
    );
};
